<template>
  <div>
    <v-dialog
      v-model="dialog"
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <p class="subtitle-1 font-weight-bold px-10 pt-8 mb-0">New Tenant</p>
        <v-stepper v-model="e1" class="px-4">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1"
              >Find User</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2"
              >Confirm User</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step step="3">Enter Details</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content
              v-if="newTenantMode == 'user'"
              step="1"
              class="pt-0"
            >
              <v-text-field
                id="username-or-email"
                v-model="username"
                name="username"
                label="Username or E-mail"
                :loading="loading"
                prepend-inner-icon="mdi-account"
                class="px-md-12 my-1"
                outlined
                dense
                @keydown.enter="next(2)"
              ></v-text-field>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="!username"
                  color="primary darken-1"
                  text
                  @click="next(2)"
                  @keydown.enter="next(2)"
                  >Next</v-btn
                >
                <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
              </v-card-actions>
            </v-stepper-content>

            <v-stepper-content step="2" class="pt-0">
              <v-form v-if="userDetails" v-model="form2">
                <v-container class="pa-0">
                  <v-row>
                    <v-col class="py-0" cols="12" sm="12" md="3">
                      <p class="caption">Name:</p>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="12" md="9">
                      <p class="caption font-weight-bold">
                        {{ userDetails.firstName }} {{ userDetails.lastname }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0" cols="12" sm="12" md="3">
                      <p class="caption">Username:</p>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="12" md="9">
                      <p class="caption font-weight-bold">
                        {{ userDetails.username }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0" cols="12" sm="12" md="3">
                      <p class="caption">Email Address:</p>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="12" md="9">
                      <p class="caption font-weight-bold">
                        {{ userDetails.email1 }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-divider class="my-3"></v-divider>
                  <v-row>
                    <v-col cols="12" md="12" class="mb-n2">
                      <p class="font-weight-bold">Additional Details</p>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        v-model="aliasName"
                        outlined
                        dense
                        label="Add an alias"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="aliasNumber"
                        outlined
                        dense
                        label="Contact Number"
                        :rules="phMobileRules"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
              <div v-if="!userDetails">
                <p class="headline">User {{ username }} does not exist</p>
                <p class="subtitle-1">
                  Create a new user with email {{ username }}?
                </p>
              </div>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary darken-1" text @click="back"
                  >Back</v-btn
                >
                <v-btn
                  v-if="userDetails"
                  color="primary darken-1"
                  text
                  :disabled="!form2"
                  @click="next(3)"
                  @keydown.enter="next(3)"
                  >Next</v-btn
                >
                <v-btn
                  v-else-if="!userDetails"
                  color="primary darken-1"
                  text
                  @click="createTempUser"
                  >Yes</v-btn
                >
                <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
              </v-card-actions>
            </v-stepper-content>
            <v-stepper-content step="3" class="pt-0">
              <v-form v-model="isFormValid">
                <v-container class="pa-0">
                  <v-row
                    v-for="(period, index) in contractPeriods"
                    :key="index"
                  >
                    <v-col class="pb-0" cols="12" sm="12" md="4">
                      <v-menu
                        v-model="period.moveInDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="period.moveInDate"
                            label="Start Date"
                            v-bind="attrs"
                            readonly
                            dense
                            outlined
                            v-on="on"
                            @click="setDateIndex(index)"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon small class="mt-1"
                                >mdi-calendar-month</v-icon
                              >
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="period.moveInDate"
                          :allowed-dates="allowedDatesMoveIn"
                          no-title
                          scrollable
                          @input="period.moveInDateMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col class="pb-0" cols="12" sm="12" md="4">
                      <v-menu
                        v-model="period.moveOutDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="period.moveOutDate"
                            label="End Date"
                            v-bind="attrs"
                            readonly
                            dense
                            outlined
                            v-on="on"
                            @click="setDateIndex(index)"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon small class="mt-1"
                                >mdi-calendar-month</v-icon
                              >
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="period.moveOutDate"
                          :allowed-dates="allowedDatesMoveOut"
                          no-title
                          scrollable
                          @input="period.moveOutDateMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col class="pb-0" cols="12" sm="12" md="4">
                      <v-currency-field
                        v-model="period.rentFee"
                        type="number"
                        :rules="rentFeeRules"
                        label="Rent Fee"
                        append-outer-icon="mdi-close"
                        dense
                        outlined
                        required
                        @click:append-outer="removePeriod(index)"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon small class="mt-1">mdi-cash</v-icon>
                        </template>
                      </v-currency-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0" cols="12" sm="12" md="4">
                      <v-btn
                        class="mt-n6"
                        text
                        x-small
                        color="primary"
                        @click="addPeriod"
                      >
                        <v-icon left x-small>mdi-plus-circle</v-icon> Add
                        another period
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider class="mb-4"></v-divider>
                  <v-row>
                    <v-col class="py-0" cols="12" sm="12" md="6">
                      <v-checkbox
                        v-model="existingUser"
                        class="my-0"
                        label="Existing tenant"
                        :disabled="firstMonthPaid"
                        hide-details
                        @change="existingUserCheckboxChange"
                      ></v-checkbox>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="12" md="6">
                      <v-menu
                        v-model="paidUntilDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        :disabled="!existingUser"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="paidUntilDate"
                            label="Next Due Date"
                            v-bind="attrs"
                            :disabled="!existingUser"
                            hide-details
                            readonly
                            outlined
                            dense
                            v-on="on"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon small class="mt-1"
                                >mdi-calendar-month</v-icon
                              >
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="paidUntilDate"
                          no-title
                          scrollable
                          @input="paidUntilDateMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pb-0">
                      <v-menu
                        v-model="nextRentalPeriod.startDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        :disabled="!existingUser"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="nextRentalPeriod.startDate"
                            label="Next rental start date"
                            v-bind="attrs"
                            :disabled="!existingUser"
                            readonly
                            outlined
                            dense
                            v-on="on"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon small class="mt-1"
                                >mdi-calendar-month</v-icon
                              >
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="nextRentalPeriod.startDate"
                          no-title
                          scrollable
                          @input="nextRentalPeriod.startDateMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col class="pb-0">
                      <v-menu
                        v-model="nextRentalPeriod.endDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        :disabled="!existingUser"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="nextRentalPeriod.endDate"
                            label="Next rental end date"
                            v-bind="attrs"
                            :disabled="!existingUser"
                            readonly
                            outlined
                            dense
                            v-on="on"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon small class="mt-1"
                                >mdi-calendar-month</v-icon
                              >
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="nextRentalPeriod.endDate"
                          no-title
                          scrollable
                          @input="nextRentalPeriod.endDateMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <!-- temporarily disable this in preference for catch up -->
                  <!-- <v-row>
                    <v-col class="py-0" cols="12" sm="12" md="12">
                      <v-checkbox
                        v-model="firstMonthPaid"
                        label="Create a rental payment for the first month"
                        :disabled="existingUser"
                      ></v-checkbox>
                    </v-col>
                  </v-row> -->

                  <v-row>
                    <v-col class="py-0" cols="12" sm="12" md="12">
                      <v-select
                        v-model="daysBeforeNotif"
                        :items="daysBeforeNotifItems"
                        label="Send rental reminder to tenant:"
                        required
                        multiple
                        chips
                        small-chips
                        outlined
                        dense
                      >
                        <template v-slot:prepend-inner>
                          <v-icon small class="mt-1">mdi-calendar-today</v-icon>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0" cols="12" sm="12" md="12">
                      <v-file-input
                        v-model="attachments"
                        accept="image/*, application/pdf"
                        label="Upload Attachments"
                        prepend-icon=""
                        chips
                        small-chips
                        multiple
                        outlined
                        dense
                      >
                        <template v-slot:prepend-inner>
                          <v-icon small class="mt-1">mdi-paperclip</v-icon>
                        </template>
                      </v-file-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-expansion-panels class="mx-4" multiple>
                      <v-expansion-panel>
                        <v-expansion-panel-header
                          >Security Deposit (Optional)</v-expansion-panel-header
                        >
                        <v-expansion-panel-content>
                          <v-container>
                            <v-row>
                              <v-col class="py-0" cols="12" sm="6" md="6">
                                <v-checkbox
                                  v-model="createSecurityDeposit"
                                  class="my-0"
                                  label="Create security deposit"
                                ></v-checkbox>
                              </v-col>
                              <v-col class="py-0" cols="12" sm="12" md="6">
                                <v-select
                                  v-model="securityDepositPaymentStatus"
                                  :items="securityDepositPaymentItems"
                                  label="Payment status"
                                  :disabled="!createSecurityDeposit"
                                  outlined
                                  dense
                                >
                                </v-select>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col class="py-0" cols="12" sm="12" md="6">
                                <v-currency-field
                                  v-model="securityDepositAmount"
                                  type="number"
                                  :rules="securityDepositRules"
                                  label="Security Deposit"
                                  prepend-inner-icon="mdi-transfer-down"
                                  :disabled="!createSecurityDeposit"
                                  hide-details
                                  required
                                  outlined
                                  dense
                                ></v-currency-field>
                              </v-col>
                              <v-col class="py-0" cols="12" sm="12" md="6">
                                <v-menu
                                  v-model="securityDepositRefundDateMenu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="securityDepositRefundDate"
                                      label="Refund Date"
                                      v-bind="attrs"
                                      :disabled="!createSecurityDeposit"
                                      readonly
                                      dense
                                      outlined
                                      v-on="on"
                                    >
                                      <template v-slot:prepend-inner>
                                        <v-icon small class="mt-1"
                                          >mdi-calendar-month</v-icon
                                        >
                                      </template>
                                    </v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="securityDepositRefundDate"
                                    no-title
                                    scrollable
                                    @input="
                                      securityDepositRefundDateMenu = false
                                    "
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header
                          >Down Payment (Optional)</v-expansion-panel-header
                        >
                        <v-expansion-panel-content>
                          <v-container>
                            <v-row>
                              <v-col class="py-0" cols="12" sm="6" md="6">
                                <v-checkbox
                                  v-model="createDownPayment"
                                  class="my-0"
                                  label="Create down payment"
                                ></v-checkbox>
                              </v-col>
                              <v-col class="py-0" cols="12" sm="12" md="6">
                                <v-select
                                  v-model="downPaymentStatus"
                                  :items="downPaymentStatusItems"
                                  label="Payment status"
                                  :disabled="!createDownPayment"
                                  outlined
                                  dense
                                >
                                </v-select>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col class="py-0" cols="12" sm="12" md="6">
                                <v-currency-field
                                  v-model="downPaymentAmount"
                                  type="number"
                                  :rules="downPaymentRules"
                                  label="Down payment"
                                  prepend-inner-icon="mdi-transfer-down"
                                  :disabled="!createDownPayment"
                                  required
                                  outlined
                                  dense
                                ></v-currency-field>
                              </v-col>
                              <v-col class="py-0" cols="12" sm="12" md="6">
                                <v-menu
                                  v-model="downPaymentDueDateMenu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="downPaymentDueDate"
                                      label="Due date"
                                      v-bind="attrs"
                                      :disabled="!createDownPayment"
                                      readonly
                                      dense
                                      outlined
                                      v-on="on"
                                    >
                                      <template v-slot:prepend-inner>
                                        <v-icon small class="mt-1"
                                          >mdi-calendar-month</v-icon
                                        >
                                      </template>
                                    </v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="downPaymentDueDate"
                                    no-title
                                    scrollable
                                    @input="downPaymentDueDateMenu = false"
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col class="py-0" cols="12" sm="6" md="6">
                                <v-menu
                                  v-model="downPaymentStartDateMenu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="downPaymentStartDate"
                                      label="Start date"
                                      v-bind="attrs"
                                      :disabled="!createDownPayment"
                                      readonly
                                      dense
                                      outlined
                                      v-on="on"
                                    >
                                      <template v-slot:prepend-inner>
                                        <v-icon small class="mt-1"
                                          >mdi-calendar-month</v-icon
                                        >
                                      </template>
                                    </v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="downPaymentStartDate"
                                    no-title
                                    scrollable
                                    @input="downPaymentStartDateMenu = false"
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col class="py-0" cols="12" sm="6" md="6">
                                <v-menu
                                  v-model="downPaymentEndDateMenu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="downPaymentEndDate"
                                      label="End date"
                                      v-bind="attrs"
                                      :disabled="!createDownPayment"
                                      readonly
                                      dense
                                      outlined
                                      v-on="on"
                                    >
                                      <template v-slot:prepend-inner>
                                        <v-icon small class="mt-1"
                                          >mdi-calendar-month</v-icon
                                        >
                                      </template>
                                    </v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="downPaymentEndDate"
                                    no-title
                                    scrollable
                                    @input="downPaymentEndDateMenu = false"
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-row>
                </v-container>
              </v-form>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary darken-1" text @click="back"
                  >Back</v-btn
                >
                <v-btn
                  color="primary darken-1"
                  :disabled="!isFormValid"
                  text
                  @click="finish"
                >
                  Finish
                </v-btn>
                <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
              </v-card-actions>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
      <CreateDepositPaymentRequest
        ref="createDepositPaymentRequest"
      ></CreateDepositPaymentRequest>
      <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-snackbar v-model="snackbar">
        {{ snackbarMessage }}
        <v-btn text color="primary" @click.native="snackbar = false"
          >Close</v-btn
        >
      </v-snackbar>
    </v-dialog>
    <v-tour
      name="tenantEmailTour"
      :steps="tourSteps"
      :callbacks="tourCallbacks"
      :options="tourOptions"
    ></v-tour>
  </div>
</template>

<script>
import { nanoid } from 'nanoid'
import { dayjs } from '../../util/date'
import CreateDepositPaymentRequest from './CreateDepositPaymentRequest.vue'

export default {
  components: {
    CreateDepositPaymentRequest
  },
  data() {
    return {
      newTenantMode: 'user',
      bedId: -1,
      dialog: false,
      resolve: null,
      reject: null,
      options: {
        color: 'primary',
        width: 700,
        zIndex: 200
      },
      loading: false,
      username: '',
      userDetails: {},
      items: [],
      search: null,
      e1: 1,
      // rentFee: 0,
      downPaymentAmount: 0,
      securityDepositAmount: 0,
      collectionDay: dayjs().date(),
      daysBeforeNotif: [1, 7],
      moveInDate: dayjs().startOf('day').format('YYYY-MM-DD'),
      moveOutDate: dayjs()
        .add(1, 'year')
        .subtract(1, 'day')
        .startOf('day')
        .format('YYYY-MM-DD'),
      paidUntilDate: dayjs().startOf('day').format('YYYY-MM-DD'),
      dateIndex: -1,
      moveInDateMenu: false,
      moveOutDateMenu: false,
      contractPeriods: [],
      paidUntilDateMenu: false,
      snackbar: false,
      snackbarMessage: '',
      downPaymentRules: [
        (v) => (v != null && v != undefined) || 'Down payment is Required.',
        (v) => Number.isInteger(parseInt(v)) || 'Down payment must be a number.'
      ],
      securityDepositRules: [
        (v) => (v != null && v != undefined) || 'Security deposit is required',
        (v) =>
          Number.isInteger(parseInt(v)) || 'Security deposit must be a number'
      ],
      rentFeeRules: [
        (v) => (v != null && v != undefined) || 'Rent fee is Required.',
        (v) => Number.isInteger(parseInt(v)) || 'Rent fee must be a number.'
        // v => v > 0 || 'Rent fee must be greater than 0'
      ],
      daysBeforeNotifItems: [
        { value: 1, text: '1 day before' },
        { value: 7, text: '1 week before' },
        { value: 14, text: '2 weeks before' },
        { value: 30, text: '30 days before' }
      ],
      existingUser: false,
      // paid: false,
      createDownPayment: false,
      createSecurityDeposit: false,
      firstMonthPaid: false,
      tourSteps: [
        {
          target: '#username-or-email',
          content: 'Enter the username or email address of your tenant here.',
          params: {
            placement: 'left'
          },
          offset: -500
        },
        {
          target: '#username-or-email',
          content:
            'This will automatically create an account for them if the tenant is not a Spacepack user.',
          params: {
            placement: 'left-start'
          },
          offset: -500
        }
      ],
      tourOptions: {
        startTimeout: 500
      },
      tourCallbacks: {
        onStop: this.stopTourCallback
      },
      isFormValid: false,
      aliasName: '',
      aliasNumber: '',
      phMobileRules: [
        (v) => {
          const pattern = /^(\+639)\d{9}$/
          return pattern.test(v) || !v || 'Please use the format +63xxxxxxxxxx'
        }
      ],
      form2: false,
      attachments: [],
      downPaymentStatus: 'pending',
      downPaymentStatusItems: [
        {
          value: 'pending',
          text: 'Pending'
        },
        {
          value: 'paid',
          text: 'Paid'
        }
      ],
      securityDepositPaymentStatus: 'pending',
      securityDepositPaymentItems: [
        {
          value: 'pending',
          text: 'Pending'
        },
        {
          value: 'paid',
          text: 'Paid'
        }
      ],
      downPaymentDueDateMenu: false,
      downPaymentDueDate: dayjs().format('YYYY-MM-DD'),
      securityDepositRefundDateMenu: false,
      securityDepositRefundDate: dayjs().format('YYYY-MM-DD'),
      nextRentalPeriod: {
        startDate: dayjs().format('YYYY-MM-DD'),
        endDate: dayjs()
          .add(1, 'month')
          .subtract(1, 'day')
          .format('YYYY-MM-DD'),
        startDateMenu: false,
        endDateMenu: false
      },
      downPaymentStartDateMenu: false,
      downPaymentStartDate: dayjs()
        .add(1, 'year')
        .subtract(3, 'month')
        .format('YYYY-MM-DD'),
      downPaymentEndDateMenu: false,
      downPaymentEndDate: dayjs()
        .add(1, 'year')
        .subtract(1, 'day')
        .format('YYYY-MM-DD'),
      idempotencyKey: null,
      addressId: undefined
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/getUser']
    }
  },
  watch: {
    search(val) {
      val && val !== this.username && this.querySelections(val)
    }
  },
  updated() {
    if (!this.user.tour || !this.user.tour['tenantEmail']) {
      this.$tours['tenantEmailTour'].start()
    }
  },
  methods: {
    open(params) {
      this.contractPeriods = [
        {
          moveInDate: this.moveInDate,
          // moveInDatePicker: this.moveInDatePicker,
          moveInDateMenu: this.moveInDateMenu,
          moveOutDate: this.moveOutDate,
          // moveOutDatePicker: this.moveOutDatePicker,
          moveOutDateMenu: this.moveOutDateMenu
        }
      ]
      this.bedId = params.bedId
      this.idempotencyKey = nanoid()
      this.dialog = true
      this.addressId = params.addressId
      //this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async next(step) {
      if (step == 2) {
        await this.$store.dispatch('users/fetchSelectedUserAction', {
          username: this.username
        })
        this.userDetails = this.$store.getters['users/getSelectedUser']
        this.aliasName = this.userDetails.alias
        this.aliasNumber = this.userDetails.aliasNumber

        if (this.userDetails) {
          this.$store
            .dispatch('units/getTenantOccupied', {
              tenantId: this.userDetails.userId
            })
            .then(() => {
              if (
                this.userDetails.userId ==
                this.$store.getters['auth/getUser'].userId
              ) {
                this.snackbarMessage = "You can't add yourself"
                this.snackbar = true
              } else {
                this.e1 = step
              }
            })
            .catch((err) => {
              this.loading = false
              this.$root.$confirm({
                title: 'New Tenant',
                message: err,
                options: {
                  color: 'warning'
                },
                reconfirmOnly: true,
                confirmText: 'OK'
              })
            })
        } else {
          if (validateEmail(this.username)) {
            this.e1 = step
          } else {
            this.snackbarMessage = 'Username does not exist'
            this.snackbar = true
          }
        }
      } else {
        this.e1 = step
      }
    },
    cancel() {
      this.e1 = 1
      this.resolve(false)
      this.dialog = false
    },
    back() {
      this.e1 -= 1
    },
    async finish() {
      this.loading = true
      // re-format contract periods to conform to local timezone
      this.contractPeriods = this.contractPeriods.map((contractPeriod) => ({
        moveInDate: dayjs(contractPeriod.moveInDate).format(),
        moveOutDate: dayjs(contractPeriod.moveOutDate).format(),
        rentFee: contractPeriod.rentFee
      }))
      try {
        const bed = await this.$store.dispatch('units/putTenantToBed', {
          tenantId: this.userDetails.userId,
          bedId: this.bedId,
          addressId: this.addressId,
          daysBeforeNotif: this.daysBeforeNotif,
          contractPeriods: this.contractPeriods,
          paidUntilDate: this.existingUser
            ? dayjs(this.paidUntilDate).format()
            : this.firstMonthPaid
            ? dayjs(this.contractPeriods[0].moveInDate).add(1, 'month').format()
            : dayjs(this.contractPeriods[0].moveInDate).format(),
          nextRentalPeriod: {
            startDate: dayjs(this.nextRentalPeriod.startDate).format(),
            endDate: dayjs(this.nextRentalPeriod.endDate).format()
          },
          alias: { name: this.aliasName, contactNumber: this.aliasNumber },
          attachments: this.attachments,
          downPayment: this.createDownPayment && {
            amount: this.downPaymentAmount,
            paymentStatus: this.downPaymentStatus,
            dueDate: dayjs(this.downPaymentDueDate).format(),
            startDate: dayjs(this.downPaymentStartDate).format(),
            endDate: dayjs(this.downPaymentEndDate).format()
          },
          securityDeposit: this.createSecurityDeposit && {
            amount: this.securityDepositAmount,
            paymentStatus: this.securityDepositPaymentStatus,
            refundDate: this.securityDepositRefundDate
          },
          idempotencyKey: this.idempotencyKey
        })

        let items = []
        // if deposit only, category is 'misc'. otherwise if it includes rent, the category is 'rental'
        let paymentCategory = 'misc'

        if (this.firstMonthPaid) {
          items.push({
            item: 'rental',
            description: `Rental for ${bed.bedName} from ${
              this.contractPeriods[0].moveInDate
            } to ${dayjs(this.contractPeriods[0].moveInDate)
              .add(1, 'month')
              .format('YYYY-MM-DD')}`,
            quantity: 1,
            amount: parseFloat(this.contractPeriods[0].rentFee)
          })
          paymentCategory = 'rental'
        }

        if (items.length) {
          await this.$store.dispatch('payments/createGenericPaymentAction', {
            tenantId: this.userDetails.userId,
            bedId: this.bedId,
            items: items,
            amountPaid: items.reduce((total, item) => total + item.amount, 0),
            startDate: dayjs(this.contractPeriods[0].moveInDate).format(),
            endDate: dayjs(this.contractPeriods[0].moveInDate)
              .add(1, 'month')
              .subtract(1, 'day')
              .format(),
            category: paymentCategory,
            leaseId: bed.leaseId
          })
        }

        this.loading = false
        this.e1 = 1
        // this.resolve(true)
        this.dialog = false
        this.username = ''
        this.$root
          .$confirm({
            title: 'New Tenant',
            message: `Tenant has been added.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(async () => {
            // window.location.reload()
            // await this.$store.dispatch('units/fetchUnitsFlatAction', {propertyId: this.user.selectedProperty.propertyId})
            return this.resolve(true)
          })
      } catch (err) {
        this.loading = false
        let message = ''
        switch (err.status) {
          case 403:
            message = 'Tenant is already occupying another unit.'
            break
          case 413:
            message = 'File size too large. Please limit your file to 2MB.'
            break
          case 415:
            message = 'Please select an image or PDF file.'
            break
          default:
            message = 'There was an error processing your request.'
        }
        this.$root.$confirm({
          title: 'Error creating lease',
          message: message,
          options: {
            color: 'warning'
          },
          reconfirmOnly: true,
          confirmText: 'OK'
        })
        this.reject(err)
      }
    },
    querySelections(v) {
      this.loading = true
      setTimeout(() => {
        this.$store
          .dispatch('users/fetchCachedUsersAction', { username: v })
          .then(() => {
            this.items = this.$store.getters['users/getCachedUsers']
            this.loading = false
          }, 5000)
      })
    },
    // formatDate (date) {
    //   if (!date) return null

    //   const [year, month, day] = date.split('-')
    //   return `${month}/${day}/${year}`
    // },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    setEnterEmail() {
      this.newTenantMode = 'email'
    },
    async createTempUser() {
      this.loading = true
      // this.username may contain username or email
      await this.$store.dispatch('users/createTempUserAction', {
        email: this.username
      })
      this.loading = false
      this.userDetails = this.$store.getters['users/getSelectedUser']
      // this.next(3)
    },
    existingUserCheckboxChange(value) {
      if (value == true) {
        this.paid = !value
      }
    },
    allowedDatesMoveOut(val) {
      const moveInDate = this.contractPeriods[this.dateIndex].moveInDate
      return dayjs(val).isAfter(dayjs(moveInDate))
      // return parseInt(val.split('-')[2], 10) % 2 === 0
    },
    allowedDatesMoveIn(val) {
      if (this.dateIndex <= 0) return true
      const previousMoveOutDate =
        this.contractPeriods[this.dateIndex - 1].moveOutDate
      return dayjs(val).isAfter(dayjs(previousMoveOutDate))
    },
    async stopTourCallback() {
      await this.$store.dispatch('auth/stopTour', { section: 'tenantEmail' })
    },
    saveMoveOutRef(index, value) {
      const ref = `moveOutDateMenuRef_${index}`
      this.$refs[ref][0].save(value)
    },
    saveMoveInRef(index, value) {
      const ref = `moveInDateMenuRef_${index}`
      this.$refs[ref][0].save(value)
    },
    addPeriod() {
      const lastIndex = this.contractPeriods.length - 1
      const lastContractPeriod = this.contractPeriods[lastIndex]
      const moveInDate = dayjs(lastContractPeriod.moveOutDate).add(1, 'day')
      const moveOutDate = moveInDate.add(1, 'year').subtract(1, 'day')
      this.contractPeriods.push({
        moveInDate: moveInDate.format('YYYY-MM-DD'),
        // moveInDatePicker: moveInDate.format('YYYY-MM-DD'),
        moveInDateMenu: false,
        moveOutDate: moveOutDate.format('YYYY-MM-DD'),
        // moveOutDatePicker: moveOutDate.format('YYYY-MM-DD'),
        moveOutDateMenu: false
      })
    },
    removePeriod(index) {
      if (index <= 0) return
      this.contractPeriods.splice(index, 1)
    },
    setDateIndex(index) {
      this.dateIndex = index
    }
    // allowedDates(val) {
    //   return parseInt(val.split('-')[2], 10) === this.collectionDay
    // },
  }
}

function validateEmail(email) {
  //eslint-disable-next-line
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
</script>

<style scoped>
.v-stepper__step {
  padding-top: 14px;
  padding-bottom: 14px;
}
.v-card.card-option {
  border-radius: 20px !important;
}
.v-stepper__header,
.v-stepper,
.v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panel {
  border-style: solid;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.12);
}
</style>
